import header from "./header.module.css";
import { exportExcel } from "../../../auxiliary/excel";
import ConfLogo from "../../../../images/confLogo.png";
import WpuLogo from "../../../../styles/svg/wpu/wpuLogo.svg";
import DisplayCounters from "../DisplayCounters/DisplayCounters";
import SearchBox from "../SearchBox/SearchBox";
import { useData } from "../../dentistContext/DentistConferenceContext";

const DentistHeader = () => {
  const { state } = useData();
  const data = state.data;

  const exportAttendence = () => {
    const tempData = data.filter((element) => {
      return (
        element.date1 ||
        element.date2 ||
        element.date3 ||
        element.date4 ||
        element.date5 ||
        element.date6
      );
    });
    exportExcel(tempData);
  };
  return (
    <div className={header.confheadercontainer}>
      <div className={header.countersWrapper}>
        <DisplayCounters />
      </div>
      <div className={header.searchWrapper}>
         <SearchBox exportAttendence={exportAttendence}/>
      </div>
      <div className={header.conflogoWrapper}>
        <img className={header.conflogo} height={100} src={ConfLogo} alt="" />
      </div>
      <div className={header.orglogoWrapper}>
        <img
          className={header.wpulogo}
          src={WpuLogo}
          alt="WPU LOGO"
          onClick={exportAttendence}
        />
      </div>
    </div>
  );
};
export default DentistHeader;
